import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateBrandApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateBrand = createAsyncThunk('updateBrand', async (payload) => {
  return await updateBrandApi(payload);
});

const updateBrandSlice = createSlice({
  name: 'updateBrand', // Unique Name
  initialState,
  reducers: {
    updateBrandReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateBrand.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateBrand.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateBrand.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateBrandReset } = updateBrandSlice.actions;

export default updateBrandSlice.reducer;
